import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';
import { JobNames } from '../../framework.core/JobNames';

export class PimsBookingListItem extends SearchModelBase {
    id: number = 0;
    fromId: number|null = null;
    toId: number|null = null;
    downloaded: boolean|null = null;
    block: boolean|null = null;
    pimsId: string = '';
    oAgent: string = '';
    dAgent: string = '';
    bookingNo: string = '';
    mblNo: string = '';
    carrierName: string = '';
    vesselName: string = '';
    voyage: string = '';
    loadingPort: string = '';
    dischargePort: string = '';
    finalDest: string = '';
    cutOff: string | null = null;
    fromCutOff: string | null = null;
    toCutOff: string | null = null;
    etd: string | null = null;
    fromEtd: string | null = null;
    toEtd: string | null = null;
    eta: string | null = null;
    fromEta: string | null = null;
    toEta: string | null = null;
    fEta: string | null = null;
    fromFEta: string | null = null;
    toFEta: string | null = null;
    containerNo: string = '';
    createdAt: string = '';

    private static AirExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: '', width: 30, dataIndex: 'status', hiddenInColumnSetup: true}),
        XCol.Create({ col: 1, text: 'iPims Ref. #', width: 100, dataIndex: 'id', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#0', noNullOrEmptySearch: true }),
        XCol.Create({ col: 2, text: 'Downloaded', width: 80, dataIndex: 'downloaded', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 3, text: 'Block', width: 60, dataIndex: 'block', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 4, text: 'Origin Agent', width: 100, dataIndex: 'oAgent'}),
        XCol.Create({ col: 5, text: 'Dest. Agent', width: 100, dataIndex: 'dAgent'}),
        XCol.Create({ col: 6, text: 'Booking #', width: 80, dataIndex: 'bookingNo', defaultColumnFocus : true}),
        XCol.Create({ col: 7, text: 'MAWB #', width: 100, dataIndex: 'mblNo'}),
        XCol.Create({ col: 8, text: 'Carrier Name', width: 120, dataIndex: 'carrierName'}),
        XCol.Create({ col: 9, text: 'FLT #', width: 60, dataIndex: 'voyage'}),
        XCol.Create({ col: 10, text: 'Loading Port', width: 120, dataIndex: 'loadingPort'}),
        XCol.Create({ col: 11, text: 'Discharge Port', width: 120, dataIndex: 'dischargePort'}),
        XCol.Create({ col: 12, text: 'Final Destination', width: 120, dataIndex: 'finalDest'}),
        XCol.Create({ col: 13, text: 'ETD', width: 75, dataIndex: 'etd', type: XCol.XCellType.Date, align: XCol.XAlignType.Center, formatString: 'MM/dd/yyyy'}),
        XCol.Create({ col: 14, text: 'ETA', width: 75, dataIndex: 'eta', type: XCol.XCellType.Date, align: XCol.XAlignType.Center, formatString: 'MM/dd/yyyy'}),
        XCol.Create({ col: 15, text: 'Final ETA', width: 75, dataIndex: 'fEta', type: XCol.XCellType.Date, align: XCol.XAlignType.Center, formatString: 'MM/dd/yyyy'}),
    ];

    private static OIExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: '', width: 30, dataIndex: 'status', hiddenInColumnSetup: true}),
        XCol.Create({ col: 1, text: 'iPims Ref. #', width: 100, dataIndex: 'id', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#0', noNullOrEmptySearch: true }),
        XCol.Create({ col: 2, text: 'Downloaded', width: 80, dataIndex: 'downloaded', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 3, text: 'Block', width: 60, dataIndex: 'block', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 4, text: 'Origin Agent', width: 100, dataIndex: 'oAgent'}),
        XCol.Create({ col: 5, text: 'Dest. Agent', width: 100, dataIndex: 'dAgent'}),
        XCol.Create({ col: 6, text: 'Booking #', width: 80, dataIndex: 'bookingNo', defaultColumnFocus : true}),
        XCol.Create({ col: 7, text: 'MBL #', width: 100, dataIndex: 'mblNo'}),
        XCol.Create({ col: 8, text: 'Vessel Carrier', width: 120, dataIndex: 'carrierName'}),
        XCol.Create({ col: 9, text: 'Vessel Name', width: 120, dataIndex: 'vesselName'}),
        XCol.Create({ col: 10, text: 'Voyage #', width: 60, dataIndex: 'voyage'}),
        XCol.Create({ col: 11, text: 'Loading Port', width: 120, dataIndex: 'loadingPort'}),
        XCol.Create({ col: 12, text: 'Discharge Port', width: 120, dataIndex: 'dischargePort'}),
        XCol.Create({ col: 13, text: 'Final Destination', width: 120, dataIndex: 'finalDest'}),
        XCol.Create({ col: 14, text: 'ETD', width: 75, dataIndex: 'etd', type: XCol.XCellType.Date, align: XCol.XAlignType.Center, formatString: 'MM/dd/yyyy'}),
        XCol.Create({ col: 15, text: 'ETA', width: 75, dataIndex: 'eta', type: XCol.XCellType.Date, align: XCol.XAlignType.Center, formatString: 'MM/dd/yyyy'}),
        XCol.Create({ col: 16, text: 'Final ETA', width: 75, dataIndex: 'fEta', type: XCol.XCellType.Date, align: XCol.XAlignType.Center, formatString: 'MM/dd/yyyy'}),
        XCol.Create({ col: 17, text: 'Container #', width: 100, dataIndex: 'containerNo'}),
    ];

    private static OEExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: '', width: 30, dataIndex: 'status', hiddenInColumnSetup: true}),
        XCol.Create({ col: 1, text: 'iPims Ref. #', width: 100, dataIndex: 'id', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#0', noNullOrEmptySearch: true }),
        XCol.Create({ col: 2, text: 'Downloaded', width: 80, dataIndex: 'downloaded', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 3, text: 'Block', width: 60, dataIndex: 'block', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 4, text: 'Origin Agent', width: 100, dataIndex: 'oAgent'}),
        XCol.Create({ col: 5, text: 'Dest. Agent', width: 100, dataIndex: 'dAgent'}),
        XCol.Create({ col: 6, text: 'Booking #', width: 80, dataIndex: 'bookingNo', defaultColumnFocus : true}),
        XCol.Create({ col: 7, text: 'MBL #', width: 100, dataIndex: 'mblNo'}),
        XCol.Create({ col: 8, text: 'Vessel Carrier', width: 120, dataIndex: 'carrierName'}),
        XCol.Create({ col: 9, text: 'Vessel Name', width: 120, dataIndex: 'vesselName'}),
        XCol.Create({ col: 10, text: 'Voyage #', width: 60, dataIndex: 'voyage'}),
        XCol.Create({ col: 11, text: 'Loading Port', width: 120, dataIndex: 'loadingPort'}),
        XCol.Create({ col: 12, text: 'Discharge Port', width: 120, dataIndex: 'dischargePort'}),
        XCol.Create({ col: 13, text: 'Final Destination', width: 120, dataIndex: 'finalDest'}),
        XCol.Create({ col: 14, text: 'CUTOFF', width: 75, dataIndex: 'cutOff', type: XCol.XCellType.Date, align: XCol.XAlignType.Center, formatString: 'MM/dd/yyyy'}),
        XCol.Create({ col: 15, text: 'ETD', width: 75, dataIndex: 'etd', type: XCol.XCellType.Date, align: XCol.XAlignType.Center, formatString: 'MM/dd/yyyy'}),
        XCol.Create({ col: 16, text: 'ETA', width: 75, dataIndex: 'eta', type: XCol.XCellType.Date, align: XCol.XAlignType.Center, formatString: 'MM/dd/yyyy'}),
        XCol.Create({ col: 17, text: 'Final ETA', width: 75, dataIndex: 'fEta', type: XCol.XCellType.Date, align: XCol.XAlignType.Center, formatString: 'MM/dd/yyyy'}),
        XCol.Create({ col: 18, text: 'Container #', width: 100, dataIndex: 'containerNo'}),
    ];

    public static getExportCollection(jobName: JobNames.OIMPims | JobNames.OIMMyPims | JobNames.OEMPims | JobNames.OEMMyPims |
        JobNames.AIMPims | JobNames.AIMMyPims | JobNames.AEMPims | JobNames.AEMMyPims): XCol.XExportColumn[] {
            switch (jobName) {
                case JobNames.AIMPims:
                case JobNames.AIMMyPims:
                case JobNames.AEMPims:
                case JobNames.AEMMyPims:
                    return this.AirExportCollection;
                case JobNames.OIMPims:
                case JobNames.OIMMyPims:
                    return this.OIExportCollection;
                case JobNames.OEMPims:
                case JobNames.OEMMyPims:
                    return this.OEExportCollection;
            }
    };
	
    public static OrderBy = { orderBy: PimsBookingListItem.prototype.id, orderByAscending: false };

    public static formatData(data: PimsBookingListItem[]) {
        return data.map((d: PimsBookingListItem) => ({
          ...d,
        }));
    }

    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        id: {from: 'fromId', to: 'toId'},
        cutOff: {from: 'fromCutOff', to: 'toCutOff'},
        etd: {from: 'fromEtd', to: 'toEtd'},
        eta: {from: 'fromEta', to: 'toEta'},
        fEta: {from: 'fromFEta', to: 'fromFEta'},
    }
}
